// extracted by mini-css-extract-plugin
export default {"bell-border":"Zalo_bell-border__jLrM0","bord-pop":"Zalo_bord-pop__xWiEF"};